import { render, staticRenderFns } from "./logout.vue?vue&type=template&id=71a03e3e&scoped=true&lang=html&"
import script from "./logout.vue?vue&type=script&lang=js&"
export * from "./logout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a03e3e",
  null
  
)

export default component.exports